import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function PricingSection() {
  const pricingPlans = [{
    name: 'Silver Plan',
    price: '£99',
    period: 'per year',
    description: 'Perfect for small teams getting started',
    features: ['Access to task scheduling', 'Basic file sharing', 'User dashboard', 'Secure login', 'Email support', 'Up to 5 team members'],
    notIncluded: ['Team collaboration tools', 'Shared workspace', 'Performance tracking', 'Priority support'],
    paymentLink: 'https://buy.stripe.com/5kQ4gy33WgjpeFTdzaeME00',
    imageGradient: 'from-slate-400 to-slate-600',
    highlighted: false
  }, {
    name: 'Gold Plan',
    price: '£120',
    period: 'per year',
    description: 'Best for growing teams',
    features: ['Everything in Silver', 'Team collaboration tools', 'Shared workspace', 'Performance tracking', 'Advanced analytics', 'Priority support', 'Up to 15 team members', 'Custom integrations'],
    notIncluded: [],
    paymentLink: 'https://buy.stripe.com/9B63cu480fflapD2UweME01',
    imageGradient: 'from-amber-400 to-orange-600',
    highlighted: true
  }];
  return <section className="py-20 bg-slate-50" data-id="element-95">
      <div className="container mx-auto px-4" data-id="element-96">
        <div className="text-center mb-12" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-98">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-99">
              Simple, Transparent Pricing
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-100">
              Choose the plan that fits your team. Annual billing with no hidden
              fees.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-101">
          {pricingPlans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative bg-white rounded-2xl shadow-lg overflow-hidden ${plan.highlighted ? 'ring-2 ring-teal-600' : ''}`} data-id="element-102">
              {plan.highlighted && <div className="absolute top-0 right-0 bg-teal-600 text-white px-4 py-1 text-sm font-semibold rounded-bl-lg" data-id="element-103">
                  Recommended
                </div>}

              {/* Image Placeholder */}
              <div className={`h-48 bg-gradient-to-br ${plan.imageGradient} flex items-center justify-center`} data-id="element-104">
                <div className="text-white text-center" data-id="element-105">
                  <div className="text-6xl font-bold opacity-20" data-id="element-106">
                    {plan.name.split(' ')[0]}
                  </div>
                </div>
              </div>

              <div className="p-8" data-id="element-107">
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-108">
                  {plan.name}
                </h3>
                <p className="text-slate-600 mb-6" data-id="element-109">{plan.description}</p>

                <div className="mb-6" data-id="element-110">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-111">
                    {plan.price}
                  </span>
                  <span className="text-slate-600 ml-2" data-id="element-112">{plan.period}</span>
                </div>

                <a href={plan.paymentLink} target="_blank" rel="noopener noreferrer" className="block mb-6" data-id="element-113">
                  <Button className="w-full" variant={plan.highlighted ? 'primary' : 'outline'} size="lg" data-id="element-114">
                    Buy Now
                  </Button>
                </a>

                <div className="space-y-3" data-id="element-115">
                  {plan.features.map((feature, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-116">
                      <Check className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-117" />
                      <span className="text-slate-700" data-id="element-118">{feature}</span>
                    </div>)}
                  {plan.notIncluded.map((feature, idx) => <div key={idx} className="flex items-start gap-3 opacity-40" data-id="element-119">
                      <X className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" data-id="element-120" />
                      <span className="text-slate-500" data-id="element-121">{feature}</span>
                    </div>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-8" data-id="element-122">
          <p className="text-slate-600 mb-4" data-id="element-123">
            Need more details?{' '}
            <a href="/services" className="text-teal-600 hover:text-teal-700 font-medium" data-id="element-124">
              View full comparison →
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}